"use client"

import { useState } from "react"

interface AboutParagraphProps {
  text: string
}

export default function AboutParagraph({ text }: AboutParagraphProps) {
  const [expanded, setExpanded] = useState(false)

  const toggleExpanded = () => {
    setExpanded(!expanded)
  }

  return (
    <>
      <h2 className="text-2xl font-semibold mb-2">About</h2>
      <p
        className={`text-gray-700 transition-all whitespace-pre-line ${
          !expanded ? "line-clamp-6" : ""
        }`}
      >
        {text?.split(/(\*\*[^*]+\*\*)/).map((part, index) => {
          if (part.startsWith("**") && part.endsWith("**")) {
            return (
              <span key={index} className="font-bold">
                {part.slice(2, -2)}
              </span>
            )
          }
          return part
        })}
      </p>
      {!expanded && (
        <button
          onClick={toggleExpanded}
          className="mt-2 text-blue-500 hover:underline"
        >
          Read More
        </button>
      )}
      {expanded && (
        <button
          onClick={toggleExpanded}
          className="mt-2 text-blue-500 hover:underline"
        >
          Hide Details
        </button>
      )}
    </>
  )
}
